import config from './config.js'

export default {

  list: function(ctrl,cat,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/scripttasks/?cat=' + encodeURIComponent(cat),'ScriptTask Liste laden',cb_success);
  },

  load: function(ctrl,id,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/scripttasks/' + encodeURIComponent(id),'ScriptTask laden',cb_success);
  },

  save: function(ctrl,data,cb_success) {
    config.put(ctrl,config.baseUrl + 'rest/scripttasks/' + encodeURIComponent(data.id),'Skript speichern',JSON.stringify(data),cb_success);
  },

  delete: function(ctrl,id,cb_success) {
    config.delete(ctrl,config.baseUrl + 'rest/scripttasks/' + encodeURIComponent(id),'ScriptTask löschen',cb_success);
  },

  test: function(ctrl,data,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/scripttasks/test','Skript testen',JSON.stringify(data),cb_success);
  },

}
